export const mobile_sound_details = [
	{
		id: 41,
		no: '2.2.1',
		label:
			'อัตราส่วนการเรียกสำเร็จ (Successful call ratio) กรณีที่เป็นการโทรศัพท์ภายในโครงข่ายของผู้ประกอบการเดียวกัน',
		targeted_text:
			'1. ช่วงเวลา 10.00 - 13.00 น. เฉลี่ยทุก 3 เดือน ไม่น้อยกว่าร้อยละ 90',
		subLabel_1:
			'1. ช่วงเวลา 10.00 - 13.00 น. เฉลี่ยทุก 3 เดือน ไม่น้อยกว่าร้อยละ 90',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 7,
		priority: 41,
	},
	{
		id: 42,
		no: '2.2.1',
		label:
			'อัตราส่วนการเรียกสำเร็จ (Successful call ratio) กรณีที่เป็นการโทรศัพท์ภายในโครงข่ายของผู้ประกอบการเดียวกัน',
		targeted_text:
			'2. ช่วงเวลา 16.00 - 19.00 น. เฉลี่ยทุก 3 เดือน ไม่น้อยกว่าร้อยละ 90',
		subLabel_1:
			'2. ช่วงเวลา 16.00 - 19.00 น. เฉลี่ยทุก 3 เดือน ไม่น้อยกว่าร้อยละ 90',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 11,
		priority: 42,
	},
	{
		id: 43,
		no: '2.2.2',
		label:
			'อัตราส่วนการเรียกสำเร็จ (Successful call ratio) กรณีที่เป็นการโทรข้ามโครงข่ายต่างผู้ประกอบการ',
		targeted_text:
			'1. ช่วงเวลา 10.00 - 13.00 น. เฉลี่ยทุก 3 เดือน ไม่น้อยกว่าร้อยละ 90',
		subLabel_1:
			'1. ช่วงเวลา 10.00 - 13.00 น.เฉลี่ยทุก 3 เดือน ไม่น้อยกว่าร้อยละ 90',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 16,
		priority: 43,
	},
	{
		id: 44,
		no: '2.2.2',
		label:
			'อัตราส่วนการเรียกสำเร็จ (Successful call ratio) กรณีที่เป็นการโทรข้ามโครงข่ายต่างผู้ประกอบการ',
		targeted_text:
			'2. ช่วงเวลา 16.00 - 19.00 น. เฉลี่ยทุก 3 เดือน ไม่น้อยกว่าร้อยละ 90',
		subLabel_1:
			'2. ช่วงเวลา 16.00 - 19.00 น. เฉลี่ยทุก 3 เดือน ไม่น้อยกว่าร้อยละ 90',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 20,
		priority: 44,
	},
	{
		id: 45,
		no: '2.2.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate)',
		targeted_text:
			'1. ช่วงเวลา 10.00 - 13.00 น. เฉลี่ยทุก 3 เดือน ไม่มากกว่าร้อยละ 2',
		subLabel_1:
			'1. ช่วงเวลา 10.00 - 13.00 น. เฉลี่ยทุก 3 เดือน ไม่มากกว่าร้อยละ 2',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 25,
		priority: 45,
	},
	{
		id: 46,
		no: '2.2.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate)',
		targeted_text:
			'2. ช่วงเวลา 16.00 - 19.00 น. เฉลี่ยทุก 3 เดือน ไม่มากกว่าร้อยละ 2',
		subLabel_1:
			'2. ช่วงเวลา 16.00 - 19.00 น. เฉลี่ยทุก 3 เดือน ไม่มากกว่าร้อยละ 2',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 29,
		priority: 46,
	},
	{
		id: 47,
		no: '2.2.4',
		label: 'คุณภาพของเสียง (Mean Opinion Score (MOS))',
		targeted_text:
			'ร้อยละ 90 ของข้อมูลที่วัดได้ ต้องไม่ต่ำกว่าค่า 2.5 (MoS Score)',
		subLabel_1: '1-ภาคเหนือ',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 36,
		priority: 47,
	},
	{
		id: 48,
		no: '2.2.4',
		label: 'คุณภาพของเสียง (Mean Opinion Score (MOS))',
		targeted_text:
			'ร้อยละ 90 ของข้อมูลที่วัดได้ ต้องไม่ต่ำกว่าค่า 2.5 (MoS Score)',
		subLabel_1: '2-ภาคใต้',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 37,
		priority: 48,
	},
	{
		id: 49,
		no: '2.2.4',
		label: 'คุณภาพของเสียง (Mean Opinion Score (MOS))',
		targeted_text:
			'ร้อยละ 90 ของข้อมูลที่วัดได้ ต้องไม่ต่ำกว่าค่า 2.5 (MoS Score)',
		subLabel_1: '3-ภาคกลาง',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 38,
		priority: 49,
	},
	{
		id: 50,
		no: '2.2.4',
		label: 'คุณภาพของเสียง (Mean Opinion Score (MOS))',
		targeted_text:
			'ร้อยละ 90 ของข้อมูลที่วัดได้ ต้องไม่ต่ำกว่าค่า 2.5 (MoS Score)',
		subLabel_1: '4-ตะวันออกเฉียงเหนือ',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 39,
		priority: 50,
	},
	{
		id: 51,
		no: '2.2.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 41,
		priority: 51,
	},
	{
		id: 52,
		no: '2.2.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 42,
		priority: 52,
	},
	{
		id: 53,
		no: '2.2.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 43,
		priority: 53,
	},
	{
		id: 54,
		no: '2.2.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 44,
		priority: 54,
	},
	{
		id: 55,
		no: '2.2.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 45,
		priority: 55,
	},
	{
		id: 200,
		no: '2.2.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 46,
		priority: 55.1,
	},
	{
		id: 56,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '00.00 - 01.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 48,
		priority: 56,
	},
	{
		id: 57,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '01.00 - 02.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 49,
		priority: 57,
	},
	{
		id: 58,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '02.00 - 03.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 50,
		priority: 58,
	},
	{
		id: 59,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '03.00 - 04.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 51,
		priority: 59,
	},
	{
		id: 60,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '04.00 - 05.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 52,
		priority: 60,
	},
	{
		id: 61,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '05.00 - 06.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 53,
		priority: 61,
	},
	{
		id: 62,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '06.00 - 07.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 54,
		priority: 62,
	},
	{
		id: 63,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '07.00 - 08.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 55,
		priority: 63,
	},
	{
		id: 64,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '08.00 - 09.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 56,
		priority: 64,
	},
	{
		id: 65,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '09.00 - 10.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 57,
		priority: 65,
	},
	{
		id: 66,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '10.00 - 11.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 58,
		priority: 66,
	},
	{
		id: 67,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '11.00 - 12.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 59,
		priority: 67,
	},
	{
		id: 68,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '12.00 - 13.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 60,
		priority: 68,
	},
	{
		id: 69,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '13.00 - 14.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 61,
		priority: 69,
	},
	{
		id: 70,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '14.00 - 15.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 62,
		priority: 70,
	},
	{
		id: 71,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '15.00 - 16.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 63,
		priority: 71,
	},
	{
		id: 72,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '16.00 - 17.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 64,
		priority: 72,
	},
	{
		id: 73,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '17.00 - 18.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 65,
		priority: 73,
	},
	{
		id: 74,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '18.00 - 19.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 66,
		priority: 74,
	},
	{
		id: 75,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '19.00 - 20.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 67,
		priority: 75,
	},
	{
		id: 76,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '20.00 - 21.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 68,
		priority: 76,
	},
	{
		id: 77,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '21.00 - 22.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 69,
		priority: 77,
	},
	{
		id: 78,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '22.00 - 23.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 70,
		priority: 78,
	},
	{
		id: 79,
		no: '2.2.5.1',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: '23.00 - 24.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 71,
		priority: 79,
	},
	{
		id: 80,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '00.00 - 01.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 73,
		priority: 80,
	},
	{
		id: 81,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '01.00 - 02.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 74,
		priority: 81,
	},
	{
		id: 82,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '02.00 - 03.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 75,
		priority: 82,
	},
	{
		id: 83,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '03.00 - 04.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 76,
		priority: 83,
	},
	{
		id: 84,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '04.00 - 05.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 77,
		priority: 84,
	},
	{
		id: 85,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '05.00 - 06.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 78,
		priority: 85,
	},
	{
		id: 86,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '06.00 - 07.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 79,
		priority: 86,
	},
	{
		id: 87,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '07.00 - 08.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 80,
		priority: 87,
	},
	{
		id: 88,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '08.00 - 09.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 81,
		priority: 88,
	},
	{
		id: 89,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '09.00 - 10.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 82,
		priority: 89,
	},
	{
		id: 90,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '10.00 - 11.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 83,
		priority: 90,
	},
	{
		id: 91,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '11.00 - 12.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 84,
		priority: 91,
	},
	{
		id: 92,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '12.00 - 13.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 85,
		priority: 92,
	},
	{
		id: 93,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '13.00 - 14.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 86,
		priority: 93,
	},
	{
		id: 94,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '14.00 - 15.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 87,
		priority: 94,
	},
	{
		id: 95,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '15.00 - 16.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 88,
		priority: 95,
	},
	{
		id: 96,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '16.00 - 17.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 89,
		priority: 96,
	},
	{
		id: 97,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '17.00 - 18.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 90,
		priority: 97,
	},
	{
		id: 98,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '18.00 - 19.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 91,
		priority: 98,
	},
	{
		id: 99,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '19.00 - 20.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 92,
		priority: 99,
	},
	{
		id: 100,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '20.00 - 21.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 93,
		priority: 100,
	},
	{
		id: 101,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '21.00 - 22.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 94,
		priority: 101,
	},
	{
		id: 102,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '22.00 - 23.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 95,
		priority: 102,
	},
	{
		id: 103,
		no: '2.2.5.2',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: '23.00 - 24.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 96,
		priority: 103,
	},
	{
		id: 104,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '00.00 - 01.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 98,
		priority: 104,
	},
	{
		id: 105,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '01.00 - 02.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 99,
		priority: 105,
	},
	{
		id: 106,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '02.00 - 03.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 100,
		priority: 106,
	},
	{
		id: 107,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '03.00 - 04.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 101,
		priority: 107,
	},
	{
		id: 108,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '04.00 - 05.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 102,
		priority: 108,
	},
	{
		id: 109,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '05.00 - 06.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 103,
		priority: 109,
	},
	{
		id: 110,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '06.00 - 07.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 104,
		priority: 110,
	},
	{
		id: 111,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '07.00 - 08.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 105,
		priority: 111,
	},
	{
		id: 112,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '08.00 - 09.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 106,
		priority: 112,
	},
	{
		id: 113,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '09.00 - 10.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 107,
		priority: 113,
	},
	{
		id: 114,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '10.00 - 11.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 108,
		priority: 114,
	},
	{
		id: 115,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '11.00 - 12.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 109,
		priority: 115,
	},
	{
		id: 116,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '12.00 - 13.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 110,
		priority: 116,
	},
	{
		id: 117,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '13.00 - 14.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 111,
		priority: 117,
	},
	{
		id: 118,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '14.00 - 15.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 112,
		priority: 118,
	},
	{
		id: 119,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '15.00 - 16.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 113,
		priority: 119,
	},
	{
		id: 120,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '16.00 - 17.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 114,
		priority: 120,
	},
	{
		id: 121,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '17.00 - 18.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 115,
		priority: 121,
	},
	{
		id: 122,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '18.00 - 19.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 116,
		priority: 122,
	},
	{
		id: 123,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '19.00 - 20.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 117,
		priority: 123,
	},
	{
		id: 124,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '20.00 - 21.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 118,
		priority: 124,
	},
	{
		id: 125,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '21.00 - 22.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 119,
		priority: 125,
	},
	{
		id: 126,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '22.00 - 23.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 120,
		priority: 126,
	},
	{
		id: 127,
		no: '2.2.5.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: '23.00 - 24.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 121,
		priority: 127,
	},
	{
		id: 128,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '00.00 - 01.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 123,
		priority: 128,
	},
	{
		id: 129,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '01.00 - 02.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 124,
		priority: 129,
	},
	{
		id: 130,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '02.00 - 03.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 125,
		priority: 130,
	},
	{
		id: 131,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '03.00 - 04.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 126,
		priority: 131,
	},
	{
		id: 132,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '04.00 - 05.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 127,
		priority: 132,
	},
	{
		id: 133,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '05.00 - 06.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 128,
		priority: 133,
	},
	{
		id: 134,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '06.00 - 07.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 129,
		priority: 134,
	},
	{
		id: 135,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '07.00 - 08.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 130,
		priority: 135,
	},
	{
		id: 136,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '08.00 - 09.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 131,
		priority: 136,
	},
	{
		id: 137,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '09.00 - 10.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 132,
		priority: 137,
	},
	{
		id: 138,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '10.00 - 11.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 133,
		priority: 138,
	},
	{
		id: 139,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '11.00 - 12.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 134,
		priority: 139,
	},
	{
		id: 140,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '12.00 - 13.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 135,
		priority: 140,
	},
	{
		id: 141,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '13.00 - 14.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 136,
		priority: 141,
	},
	{
		id: 142,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '14.00 - 15.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 137,
		priority: 142,
	},
	{
		id: 143,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '15.00 - 16.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 138,
		priority: 143,
	},
	{
		id: 144,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '16.00 - 17.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 139,
		priority: 144,
	},
	{
		id: 145,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '17.00 - 18.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 140,
		priority: 145,
	},
	{
		id: 146,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '18.00 - 19.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 141,
		priority: 146,
	},
	{
		id: 147,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '19.00 - 20.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 142,
		priority: 147,
	},
	{
		id: 148,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '20.00 - 21.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 143,
		priority: 148,
	},
	{
		id: 149,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '21.00 - 22.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 144,
		priority: 149,
	},
	{
		id: 150,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '22.00 - 23.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 145,
		priority: 150,
	},
	{
		id: 151,
		no: '2.2.5.4',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: '23.00 - 24.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 146,
		priority: 151,
	},
	{
		id: 152,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '00.00 - 01.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 148,
		priority: 152,
	},
	{
		id: 153,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '01.00 - 02.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 149,
		priority: 153,
	},
	{
		id: 154,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '02.00 - 03.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 150,
		priority: 154,
	},
	{
		id: 155,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '03.00 - 04.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 151,
		priority: 155,
	},
	{
		id: 156,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '04.00 - 05.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 152,
		priority: 156,
	},
	{
		id: 157,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '05.00 - 06.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 153,
		priority: 157,
	},
	{
		id: 158,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '06.00 - 07.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 154,
		priority: 158,
	},
	{
		id: 159,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '07.00 - 08.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 155,
		priority: 159,
	},
	{
		id: 160,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '08.00 - 09.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 156,
		priority: 160,
	},
	{
		id: 161,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '09.00 - 10.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 157,
		priority: 161,
	},
	{
		id: 162,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '10.00 - 11.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 158,
		priority: 162,
	},
	{
		id: 163,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '11.00 - 12.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 159,
		priority: 163,
	},
	{
		id: 164,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '12.00 - 13.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 160,
		priority: 164,
	},
	{
		id: 165,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '13.00 - 14.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 161,
		priority: 165,
	},
	{
		id: 166,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '14.00 - 15.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 162,
		priority: 166,
	},
	{
		id: 167,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '15.00 - 16.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 163,
		priority: 167,
	},
	{
		id: 168,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '16.00 - 17.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 164,
		priority: 168,
	},
	{
		id: 169,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '17.00 - 18.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 165,
		priority: 169,
	},
	{
		id: 170,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '18.00 - 19.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 166,
		priority: 170,
	},
	{
		id: 171,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '19.00 - 20.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 167,
		priority: 171,
	},
	{
		id: 172,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '20.00 - 21.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 168,
		priority: 172,
	},
	{
		id: 173,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '21.00 - 22.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 169,
		priority: 173,
	},
	{
		id: 174,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '22.00 - 23.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 170,
		priority: 174,
	},
	{
		id: 175,
		no: '2.2.5.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: '23.00 - 24.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 171,
		priority: 175,
	},
	{
		id: 176,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '00.00 - 01.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 173,
		priority: 176,
	},
	{
		id: 177,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '01.00 - 02.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 174,
		priority: 177,
	},
	{
		id: 178,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '02.00 - 03.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 175,
		priority: 178,
	},
	{
		id: 179,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '03.00 - 04.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 176,
		priority: 179,
	},
	{
		id: 180,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '04.00 - 05.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 177,
		priority: 180,
	},
	{
		id: 181,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '05.00 - 06.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 178,
		priority: 181,
	},
	{
		id: 182,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '06.00 - 07.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 179,
		priority: 182,
	},
	{
		id: 183,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '07.00 - 08.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 180,
		priority: 183,
	},
	{
		id: 184,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '08.00 - 09.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 181,
		priority: 184,
	},
	{
		id: 185,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '09.00 - 10.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 182,
		priority: 185,
	},
	{
		id: 186,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '10.00 - 11.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 183,
		priority: 186,
	},
	{
		id: 187,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '11.00 - 12.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 184,
		priority: 187,
	},
	{
		id: 188,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '12.00 - 13.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 185,
		priority: 188,
	},
	{
		id: 189,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '13.00 - 14.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 186,
		priority: 189,
	},
	{
		id: 190,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '14.00 - 15.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 187,
		priority: 190,
	},
	{
		id: 191,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '15.00 - 16.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 188,
		priority: 191,
	},
	{
		id: 192,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '16.00 - 17.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 189,
		priority: 192,
	},
	{
		id: 193,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '17.00 - 18.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 190,
		priority: 193,
	},
	{
		id: 194,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '18.00 - 19.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 191,
		priority: 194,
	},
	{
		id: 195,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '19.00 - 20.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 192,
		priority: 195,
	},
	{
		id: 196,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '20.00 - 21.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 193,
		priority: 196,
	},
	{
		id: 197,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '21.00 - 22.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 194,
		priority: 197,
	},
	{
		id: 198,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '22.00 - 23.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 195,
		priority: 198,
	},
	{
		id: 199,
		no: '2.2.5.6',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่มากกว่าร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: '23.00 - 24.00 น.',
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition:
			'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: false,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['F', 'G', 'H', 'I'],
		excelValueRow: 196,
		priority: 199,
	},
]
